<template>
  <datalist
    v-bind="$attrs"
  >
    <option
      v-for="item in list"
      :key="makeKey('data_list_option', item)"
      :value="item"
    />
  </datalist>
</template>

<script>
export default {
  name: 'DataList',
  props: {
    list: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
};
</script>
